import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full grid lg:grid-cols-2 divide-y lg:divide-y-0 lg:divide-x divide-neutral-900" }
const _hoisted_2 = { class: "lg:sticky lg:top-0 lg:left-0 w-full lg:h-screen flex flex-col bg-black" }
const _hoisted_3 = { class: "relative bg-black p-8 lg:py-32" }
const _hoisted_4 = { class: "flex flex-col w-full max-w-lg mx-auto" }
const _hoisted_5 = { class: "mb-8 lg:mb-16 self-start" }
const _hoisted_6 = { class: "title mb-8" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Claim your ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" CAMPUS airdrop ")
const _hoisted_9 = { class: "mb-8" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Every ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" NFT holder receives an airdrop of it's associated CAMPUS NFT. Just follow the steps below to assert your claim (it's free, you'll just need to cover the transaction fees) ")
const _hoisted_12 = { class: "space-y-4 rounded-xl p-4 border-2 border-neutral-400/50" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { class: "title-3" }, "You're too early", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg" }, " This feature is not available in the current sale phase. ", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Return to Homepage")

import { ref } from "vue";
import AirdropSteps from "@/views/airdrop/src/AirdropSteps.vue";
import AirdropPreview from "@/views/airdrop/src/AirdropPreview.vue";
import AppButtonBackOrHome from "@/components/app/AppButtonBackOrHome.vue";
import AppButton from "@/components/app/AppButton.vue";

import { routes } from "@/constants/";
import DripversityIcon from "@/components/icons/DripversityIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AirdropView',
  setup(__props) {

const tokens = ref([]);
const preview = ref<typeof AirdropPreview>();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AirdropPreview, {
        ref_key: "preview",
        ref: preview,
        alt: 'Airdrop Placeholder'
      }, null, 512)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(AppButtonBackOrHome)
        ]),
        _createElementVNode("h1", _hoisted_6, [
          _hoisted_7,
          _createVNode(DripversityIcon, { class: "text-dripversity w-52" }),
          _hoisted_8
        ]),
        _createElementVNode("p", _hoisted_9, [
          _hoisted_10,
          _createVNode(DripversityIcon, { class: "text-dripversity" }),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _hoisted_14,
          _createVNode(AppButton, {
            color: "outline",
            size: "sm",
            to: _unref(routes).home.Home
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}
}

})